import { Text } from '@croquiscom-pvt/zds';

import { CustomInputProps } from '../../../type/common.type';

import { Input, InputBox, Label, Shadow, valueLength, Wrapper } from './CustomInputItem.css';

export const CustomInputItem = ({
  name,
  value,
  placeholder,
  maxLength,
  inputEl,
  shadowEl,
  focused,
  labelHeight,
  handleChange = () => undefined,
  handleFocus = () => undefined,
  handleBlur = () => undefined,
  handleKeydown = () => undefined,
}: CustomInputProps) => {
  const displayLabel = !!name;
  return (
    <Wrapper>
      {displayLabel && (
        <Text variant='Body_13_SemiBold' color='gray500'>
          <Shadow ref={shadowEl}>{name}</Shadow>
          <Label className={focused ? 'focus' : ''} {...(focused && { style: { height: labelHeight } })}>
            {name}
          </Label>
        </Text>
      )}
      <InputBox className={focused ? 'focus' : ''}>
        <Input
          ref={inputEl}
          type='text'
          value={value}
          placeholder={placeholder}
          onChange={handleChange}
          onFocus={handleFocus}
          onBlur={handleBlur}
          onKeyDown={handleKeydown}
        />
        <Text variant='Body_13_SemiBold' v3Color='gray300' css={valueLength}>
          {value.length}/{maxLength}
        </Text>
      </InputBox>
    </Wrapper>
  );
};
